var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app_top_image",style:({backgroundImage: `url(${_vm.background})`})},[_c('div',{staticClass:"company_logo"},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }